import React, { useEffect, useState } from 'react';
import { usePortal } from '../../contexts/PortalContext';
import type { Deliverable } from '../../types/portal';
import { fetchTranscriptComments, type TranscriptComment } from '../../utils/transcriptComments';
import { formatEditStamp } from '../../utils/time';

/**
 * The comments clients have left on this transcript, exactly as stored — the
 * same rows the client sees, read here so Portal is never working from a
 * different record.
 */
export function TranscriptComments({
  deliverable
}: {
  deliverable: Deliverable;
}) {
  const {
    activeProject,
    clientName
  } = usePortal();
  const [comments, setComments] = useState<TranscriptComment[]>([]);
  useEffect(() => {
    let live = true;
    void fetchTranscriptComments(activeProject.slug, deliverable.id, clientName).then(result => {
      if (!live || result.status !== 'ok') return;
      setComments(result.comments);
    });
    return () => {
      live = false;
    };
  }, [activeProject.slug, deliverable.id, clientName]);
  if (comments.length === 0) return null;
  return <div className="mt-12" data-id="element-381" data-mp="3vm8ft5rwpkm5">
      <h4 className="label border-b border-ruleDark pb-4 text-paper/40" data-id="element-382" data-mp="3rmzl9yp1lipj">Transcript Comments</h4>
      <ul className="m-0 list-none p-0" data-id="element-383" data-mp="98gkxlj98cpl">
        {comments.map(comment => <li key={comment.id} className="border-b border-ruleDark py-5" data-id="element-384" data-mp="9akzqyioyw4n">
            {comment.quote && <p className="m-0 border-l-2 border-ruleDark pl-4 font-display text-base leading-snug text-paper/40" data-id="element-385" data-mp="j6wa3iyq1bwg">
                “{comment.quote}”
              </p>}
            <p className="mt-2 font-display text-lg font-normal leading-relaxed text-paper/70" data-id="element-386" data-mp="e9xj39actl2h">
              {comment.body}
            </p>
            <span className="label-sm mt-2 block text-paper/30" data-id="element-387" data-mp="n7zos25191w3">
              {comment.authorName} · {formatEditStamp(comment.at)}
            </span>
          </li>)}
      </ul>
    </div>;
}